<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-09-20 08:58:22
 * @LastEditTime : 2026-03-26 16:02:26
 * @LastEditors  : yangxr
 * @Description  : 结算任务确认
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\settlementTaskSure.vue
-->
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main>
                <div class="tabtop" style="width: 754px">
                    <div v-for="(item, index) in typelist" :key="index" @click="choose(item.status)">
                        <div :class="currenindex == item.status ? 'active' : 'text'">
                            {{ item.value }}
                        </div>
                    </div>
                    <el-button v-if="currenindex == 1 || currenindex == 4" size="mini" style="margin-left:24px"
                        class="bottom_all but1" @click="monthReportAdd()">生成结算</el-button>
                </div>
                <!-- <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </div>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
          </el-collapse-transition> -->
                <div class="hr"></div>
                <div class="card">
                    <div v-loading="tableLoading" class="card_info" :style="style">
                        <el-table :key="currenindex" :header-cell-style="{ background: '#f3f6f9' }"
                            :cell-style="{ borderRight: 'none' }" :height="screenHeight - 350" border stripe
                            style="width: 100%;margin-top:10px" :data="tableData" tooltip-effect="dark">
                            <el-table-column align="center" label="工程编号" prop="engineeringCode"
                                min-width="230"></el-table-column>
                            <el-table-column align="center" label="工程名称" min-width="230"
                                prop="engineeringName"></el-table-column>
                            <!-- <el-table-column v-if="currenindex == 4"  align="center" label="合同单位" min-width="230"
                                prop="engineeringName"></el-table-column> -->
                            <el-table-column align="center" label="结算周期" min-width="230" prop="">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.lastDueTime }}-{{ scope.row.currentDueTime }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="settleType" label="结算类型" min-width="80" prop="engineeringName">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.settleType == 1">过程结算</span>
                                    <span v-if="scope.row.settleType == 2">总结算</span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="currenindex !== 1" align="settleType" label="结算方式" min-width="80"
                                prop="paymentMethod">
                            </el-table-column>
                            <el-table-column v-if="currenindex !== 1" align="center" label="内审量" min-width="80"
                                prop="insideExamineAmount"></el-table-column>
                            <el-table-column v-if="currenindex !== 1" align="center" label="富余量" min-width="80"
                                prop="marginAmount"></el-table-column>
                            <el-table-column v-if="currenindex !== 1" align="center" label="过磅扣减量" min-width="80"
                                prop="deductionAmount"></el-table-column>
                            <el-table-column v-if="currenindex == 1" align="center" label="审核状态" prop="settleStatus">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.settleStatus == 0">待结算</span>
                                    <span v-if="scope.row.settleStatus == 1">已结算</span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="currenindex == 2 || currenindex == 3" align="center" label="是否主工程"
                                prop="settleStatus">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.masterProjectOrNot == 0">否</span>
                                    <span v-if="scope.row.masterProjectOrNot == 1">是</span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="currenindex == 2" align="center" label="审核状态"
                                prop="insideExamineSettlesStatus">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.insideExamineSettlesStatus == 0">待保存</span>
                                    <span v-else-if="scope.row.insideExamineSettlesStatus == 1">审核通过</span>
                                    <span v-else-if="scope.row.insideExamineSettlesStatus == 2">审核中</span>
                                    <span v-else-if="scope.row.insideExamineSettlesStatus == 3">审核不通过</span>
                                    <span v-else-if="scope.row.insideExamineSettlesStatus == 4">主工程占用</span>
                                    <span v-else>待提交</span>
                                </template>

                            </el-table-column>
                            <el-table-column v-if="currenindex == 3" align="center" label="审核状态" prop="sureSelletesStatus">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.sureSelletesStatus == 0">待保存</span>
                                    <span v-else-if="scope.row.sureSelletesStatus == 1">审核通过</span>
                                    <span v-else-if="scope.row.sureSelletesStatus == 2">审核中</span>
                                    <span v-else-if="scope.row.sureSelletesStatus == 3">审核不通过</span>
                                    <span v-else-if="scope.row.sureSelletesStatus == 4">主工程占用</span>
                                    <span v-else>待提交</span>
                                </template>

                            </el-table-column>
                            <el-table-column v-if="currenindex == 4" align="center" label="审核状态" prop="settleStatus">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.settleStatus == 1">待审核</span>
                                    <span v-else-if="scope.row.settleStatus == 2">审核中</span>
                                    <span v-else-if="scope.row.settleStatus == 3">审核不通过</span>
                                    <span v-else-if="scope.row.settleStatus == 4">已审核</span>
                                    <span v-else>待结算</span>
                                </template>

                            </el-table-column>
                            <el-table-column v-if="currenindex !== 1" align="center" label="附件" prop="supplyPhase">
                                <template slot-scope="scope">
                                    <el-button class="bottom_one" size="mini" @click="lookFile(scope.row)">查看</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="currenindex == 1" label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-link v-if="scope.row.settleStatus == 0" type="danger" :underline="false"
                                        @click="deleteBill(scope.row)">删除</el-link>
                                    <el-link v-if="scope.row.settleStatus == 0" type="success" style="margin-left: 10px;"
                                        :underline="false" @click="billOpen(scope.row, true)">确认结算单</el-link>

                                    <el-link v-else type="primary" :underline="false"
                                        @click="billOpen(scope.row, false)">查看</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="currenindex == 2" label="操作" align="center" width="150">
                                <template slot-scope="scope">
                                    <el-link
                                        v-if="scope.row.insideExamineSettlesStatus == 0 || scope.row.insideExamineSettlesStatus == 5 || scope.row.insideExamineSettlesStatus == 3 || scope.row.insideExamineSettlesStatus == 4"
                                        type="danger" style="margin-right: 10px;" :underline="false"
                                        @click="deleteInsideBill(scope.row)">删除</el-link>
                                    <el-link
                                        v-if="scope.row.insideExamineSettlesStatus == 1 || scope.row.insideExamineSettlesStatus == 2 || scope.row.insideExamineSettlesStatus == 4"
                                        type="primary" style="margin-right: 10px;" :underline="false"
                                        @click="billOpen(scope.row, false)">查看</el-link>
                                    <el-link v-if="scope.row.insideExamineSettlesStatus == 0" type="success"
                                        style="margin-right: 10px;" :underline="false"
                                        @click="billOpen(scope.row, true)">保存</el-link>
                                    <el-link
                                        v-if="scope.row.insideExamineSettlesStatus == 5 || scope.row.insideExamineSettlesStatus == 3"
                                        style="margin-right: 10px;" type="success" :underline="false"
                                        @click="billOpen(scope.row, true)">修改</el-link>
                                    <el-link
                                        v-if="scope.row.insideExamineSettlesStatus == 5 || scope.row.insideExamineSettlesStatus == 3"
                                        type="warning" :underline="false"
                                        @click="billOpen(scope.row, false, false, true)">提交</el-link>
                                    <el-link
                                        v-if="scope.row.insideExamineSettlesStatus == 1 && ButtonList.findIndex(res => (res.buttonValue == 'CHEHUI')) !== -1"
                                        type="warning" :underline="false"
                                        @click="billOpen(scope.row, false, false, false, false, true)">撤回</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="currenindex == 3" label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-link
                                        v-if="scope.row.sureSelletesStatus == 1 || scope.row.sureSelletesStatus == 2 || scope.row.sureSelletesStatus == 4"
                                        type="primary" style="margin-right: 10px;" :underline="false"
                                        @click="billOpen(scope.row, false)">查看</el-link>
                                    <el-link v-if="scope.row.sureSelletesStatus == 0" type="success"
                                        style="margin-right: 10px;" :underline="false"
                                        @click="billOpen(scope.row, true)">保存</el-link>
                                    <el-link v-if="scope.row.sureSelletesStatus == 5 || scope.row.sureSelletesStatus == 3"
                                        style="margin-right: 10px;" type="success" :underline="false"
                                        @click="billOpen(scope.row, true)">修改</el-link>
                                    <el-link v-if="scope.row.sureSelletesStatus == 5 || scope.row.sureSelletesStatus == 3"
                                        type="warning" :underline="false"
                                        @click="billOpen(scope.row, false, false, true)">提交</el-link>
                                    <el-link v-if="scope.row.sureSelletesStatus == 5 || scope.row.sureSelletesStatus == 3"
                                        type="warning" :underline="false" @click="goback(scope.row)">重置</el-link>
                                    <!-- <el-link type="success" :underline="false"
                                        @click="handleFinish(scope.row)">取消审核 </el-link> -->
                                    <el-link
                                        v-if="scope.row.sureSelletesStatus == 1 && ButtonList.findIndex(res => (res.buttonValue == 'CHEHUI')) !== -1"
                                        type="warning" :underline="false"
                                        @click="billOpen(scope.row, false, false, false, false, true)">撤回</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="currenindex == 4" label="操作" align="center" width="150">
                                <template slot-scope="scope">
                                    <el-link
                                        v-if="scope.row.settleStatus == 0 || scope.row.settleStatus == 1 || scope.row.settleStatus == 3"
                                        type="danger" style="margin-right: 10px;" :underline="false"
                                        @click="deleteProcess(scope.row)">删除</el-link>
                                    <el-link v-if="scope.row.settleStatus == 0" type="success" :underline="false"
                                        @click="billOpen(scope.row, true)">确认结算单</el-link>
                                    <el-link v-if="scope.row.settleStatus == 4 || scope.row.settleStatus == 2"
                                        type="primary" :underline="false" @click="billOpen(scope.row, false)">查看</el-link>

                                    <el-link v-if="scope.row.settleStatus == 1 || scope.row.settleStatus == 3"
                                        type="success" :underline="false" @click="billOpen(scope.row, true)">审核</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-main>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableDataNew()"></el-pagination>
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableDataNew">刷新</el-button>
                </div>
            </div>
        </el-container>
        <!-- 结算单-查看修改添加 -->
        <el-dialog :visible.sync="billDig" width="1280px" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">混凝土结算</span>
            <div class="bill_top">
                <!-- <span><span class="text">工程名称：</span>{{ low.engineeringName }}</span> -->
                <span v-if="mainRow.masterProjectOrNot == 1"><span class="text">工程名称：</span>
                    <el-select v-model="cycleId" style="width: 120px" placeholder="请选择">
                        <el-option :key="1" label="汇总" :value="1"
                            @click.native="changeEng(mainRow, false, true)"></el-option>
                        <el-option :key="mainRow.id" label="主工程" :value="mainRow.id"
                            @click.native="changeEng(mainRow, false)"></el-option>
                        <el-option v-for="item in bindEngList" :key="item.childCycleId" :label="item.engineeringName"
                            :value="item.childCycleId" @click.native="changeEng(item, true)"></el-option>
                    </el-select>
                </span>
                <span style="margin-left:24px"><span class="text">结算时间段：</span>{{ low.lastDueTime }}至{{ low.currentDueTime
                }}</span>
                <el-button v-if="currenindex !== 4 && low.masterProjectOrNot == 1" size="mini" class="bottom_all"
                    style="margin-left: 24px" @click="openEngBind(true)">绑定工程</el-button>
                <el-popover v-if="!isLook && currenindex == 2" v-model="generateSettlementVisible" placement="top"
                    width="288">
                    <el-select v-model="generateSettlementType" style="width: 180px" placeholder="请选择">
                        <el-option :key="1" label="月报价" :value="1"></el-option>
                        <el-option :key="2" label="合同价" :value="2"></el-option>
                    </el-select>
                    <div style="text-align: right; margin-top: 12px">
                        <el-button class="bottom_all_two" @click="generateSettlementVisible = false">取消</el-button>
                        <el-button class="bottom_all_two" style="margin-left: 24px"
                            @click="generateSettlement()">确定</el-button>
                    </div>
                    <el-button slot="reference" size="default" class="bottom_all" style="margin-left: 24px">生成结算</el-button>
                </el-popover>
                <el-button v-if="!isLook && currenindex == 4" size="mini" class="bottom_all" style="margin-left: 24px"
                    @click="generateSettlement()">生成结算</el-button>
                <el-button v-if="currenindex !== 4" size="mini" class="bottom_all" style="margin-left: 24px"
                    @click="lookDialog1">查看调价</el-button>
                <el-button v-if="currenindex !== 4" size="mini" class="bottom_all" style="margin-left: 24px"
                    @click="priceMaintenanceDig = true">查看信息价</el-button>
                <el-button size="mini" class="bottom_all" style="margin-left: 24px"
                    @click="LookcheckDetail">核对明细单</el-button>
                <el-button v-if="currenindex !== 4" size="mini" class="bottom_all" style="margin-left: 24px"
                    @click="downLoad()">导出</el-button>
            </div>
            <!-- 产品结算 -->
            <!-- <div class="bill_title1" style="padding-bottom: 15px">
                <el-button v-if="currenindex !== 1 && !isLook" size="mini" class="bottom_all" style="margin-left: 24px"
                    @click="addItem('productSummarys')">
                    <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                    添加
                </el-button>
            </div> -->
            <vxe-table ref="table1" border show-footer show-overflow="tooltip" height="400" align="center"
                :data="billData.productSummarys" :row-config="{ isHover: true }" :column-config="{ resizable: true }"
                :scroll-y="{ enabled: true }" :footer-method="footerMethod1">
                <!-- <vxe-column field="stationName" title="站点信息" width="150">
                    <template #default="{ row }">
                        <el-select v-model="row.stationId" style="width: 120px" :disabled="isLook" placeholder="请选择站点">
                            <el-option v-for="item in stationIdlist" :key="item.stationId" :label="item.stationName"
                                :value="item.stationId"
                                @click.native="row.stationName = item.stationName; row.stationCode = item.code"></el-option>
                        </el-select>
                    </template>
                </vxe-column> -->
                <vxe-column field="startTime" title="价格时间段" width="250" :tooltip="true">
                    <template #default="{ row }">
                        <span v-if="row.startTime">{{ row.startTime }}-{{ row.endTime }}</span>
                        <span v-else>-</span>
                    </template>
                </vxe-column>
                <vxe-column field="sex" title="结算项" width="150">
                    <template #default="{ row }">
                        <el-select v-model="row.settleItem" style="width: 120px" :disabled="isLook" placeholder="请选择">
                            <el-option v-for="item in settleItemList" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column field="productName" title="产品名称">
                    <template #default="{ row }">
                        <el-input v-model="row.productName" placeholder="请输入" :disabled="isLook"
                            style="width: 100%"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="amount" title="数量(m³)">
                    <template #default="{ row }">
                        <el-input v-model="row.amount" placeholder="请输入" disabled style="width: 100%"
                            onkeypress="return( /\d|\.|-/.test(String.fromCharCode(event.keyCode)))"
                            @input="row.amount = $regExp.checkNum3(row.amount)"
                            @blur="row.amount = $regExp.blurCheckNum(row.amount, true)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column v-if="currenindex !== 4" field="basicPrice" title="基本单价(元/m³)">
                    <template #default="{ row }">
                        <el-input v-model="row.basicPrice" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                            @input="row.basicPrice = $regExp.checkNum(row.basicPrice)"
                            @blur="row.basicPrice = $regExp.blurCheckNum(row.basicPrice)"></el-input>
                    </template>
                </vxe-column>
                <vxe-colgroup v-if="currenindex !== 4" :key="billData.additional.join('-')" field="" title="附加收费项(元/m³)">
                    <template v-for="(item) in billData.additional">
                        <vxe-column v-if="item" :key="item" :field="item" :title="item">
                            <template #default="{ row, rowIndex }">
                                <el-input :key="item + rowIndex" v-model="row[item]" placeholder="请输入" :disabled="isLook"
                                    style="width: 100%"
                                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                                    @input="e => additionalPrice(rowIndex, item, e)"
                                    @blur="additionalPriceBlur(rowIndex, item)"></el-input>
                            </template>
                        </vxe-column>
                    </template>
                </vxe-colgroup>
                <vxe-column v-if="currenindex !== 4" field="totalUnitPrice" title="结算单价(元/m³)">
                </vxe-column>
                <vxe-column v-if="currenindex !== 4" field="totalMoney" title="结算额(元)">
                </vxe-column>
                <!-- <vxe-column v-if="currenindex !== 1 && !isLook" field="" title="操作">
                    <template #default="{ rowIndex }">
                        <el-button size="mini" class="bottom_two" @click="delItem(rowIndex, 'productSummarys')">
                            <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                            删除
                        </el-button>
                    </template>
                </vxe-column> -->
            </vxe-table>
            <!-- 调价结算 -->
            <div v-if="currenindex !== 4" class="bill_title1" style="padding-bottom: 15px">
                <el-button v-if="currenindex !== 1 && !isLook" size="mini" class="bottom_all" style="margin-left: 24px"
                    @click="addItem('differSummarys')">
                    <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                    添加
                </el-button>
            </div>
            <vxe-table v-if="currenindex !== 4" key="table2" ref="table2" border show-footer show-overflow align="center"
                :data="billData.differSummarys" :row-config="{ isHover: true }" :column-config="{ resizable: true }"
                :scroll-y="{ enabled: true }" :footer-method="footerMethod2">

                <vxe-column field="sex" title="调价时间段" width="400">
                    <template #default="{ row, rowIndex }">
                        <el-date-picker v-model="row.timeSlot" style="width:380px" value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange" :default-time="['00:00:00', '23:59:59']" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" @change="e => changeTimeSlot(e, rowIndex)">
                        </el-date-picker>
                    </template>
                </vxe-column>
                <vxe-column field="stationName" title="调整类型" width="150">
                    <template #default="{ row }">
                        <el-select v-model="row.adjustTypeId" style="width: 120px" :disabled="isLook" placeholder="请选择站点">
                            <el-option v-for="item in adjustTypeList" :key="item.itemValue" :label="item.itemName"
                                :value="item.itemValue" @click.native="row.adjustType = item.itemName"></el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column field="productName" title="产品名称">
                    <template #default="{ row }">
                        <el-input v-model="row.productName" placeholder="请输入" :disabled="isLook"
                            style="width: 100%"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="amount" title="数量(m³)">
                    <template #default="{ row }">
                        <el-input v-model="row.amount" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                            @input="row.amount = $regExp.checkNum3(isLookrow.amount)"
                            @blur="row.amount = $regExp.blurCheckNum(row.amount)"></el-input>
                    </template>
                </vxe-column>
                <!-- <vxe-column field="amount" title="信息价期数">
                    <template #default="{ row }">
                        <el-input v-model="row.amount" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                            @input="row.amount = $regExp.checkNum(row.amount)"
                            @blur="row.amount = $regExp.blurCheckNum(row.amount)"></el-input>
                    </template>
                </vxe-column> -->
                <vxe-column field="differPrice" title="价差(元)">
                    <template #default="{ row }">
                        <el-input v-model="row.differPrice" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /[0-9\.\-]/.test(String.fromCharCode(event.keyCode)))"
                            @input="row.differPrice = $regExp.checkNum4(row.differPrice)"
                            @blur="row.differPrice = $regExp.blurCheckNum(row.differPrice, true)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="alreadySettlePrice" title="已办结算价（元）">
                    <template #default="{ row }">
                        <el-input v-model="row.alreadySettlePrice" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /[0-9\.\-]/.test(String.fromCharCode(event.keyCode)))"
                            @input="row.alreadySettlePrice = $regExp.checkNum(row.alreadySettlePrice)"
                            @blur="row.alreadySettlePrice = $regExp.blurCheckNum(row.alreadySettlePrice, true)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="newAdjustPrice" title="应办结算价（元）">
                    <template #default="{ row }">
                        <el-input v-model="row.newAdjustPrice" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /[0-9\.\-]/.test(String.fromCharCode(event.keyCode)))"
                            @input="row.newAdjustPrice = $regExp.checkNum(row.newAdjustPrice)"
                            @blur="row.newAdjustPrice = $regExp.blurCheckNum(row.newAdjustPrice, true)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="differMoney" title="结算额(元)">
                </vxe-column>
                <vxe-column field="remark" title="备注">
                    <template #default="{ row }">
                        <el-input v-model="row.remark" placeholder="请输入" :disabled="isLook" style="width: 100%"></el-input>
                    </template>
                </vxe-column>
                <vxe-column v-if="currenindex !== 1 && !isLook" field="" title="操作">
                    <template #default="{ rowIndex }">
                        <el-button size="mini" class="bottom_two" @click="delItem(rowIndex, 'differSummarys')">
                            <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                            删除
                        </el-button>
                    </template>
                </vxe-column>
            </vxe-table>
            <div class="bill_title1" style="padding-bottom: 15px">泵类别结算合计
                <!-- <el-button v-if="currenindex !== 1 && !isLook"
                    size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem('pumpSummarys')">
                    <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                    添加
                </el-button> -->
            </div>
            <vxe-table key="table3" ref="table3" border show-footer show-overflow align="center"
                :data="billData.pumpSummarys" :row-config="{ isHover: true }" :column-config="{ resizable: true }"
                :scroll-y="{ enabled: true }" :footer-method="footerMethod3">
                <vxe-column field="product" title="产品名称">
                </vxe-column>
                <vxe-column field="amount" title="数量(m³)">
                </vxe-column>
                <vxe-column v-if="currenindex !== 4" field="basicPrice" title="基本单价(元/m³)">
                </vxe-column>
                <vxe-column v-if="currenindex !== 4" field="settlePrice" title="结算单价(元/m³)">
                </vxe-column>
                <vxe-column v-if="currenindex !== 4" field="totalMoney" title="结算额(元)">
                </vxe-column>
            </vxe-table>
            <div class="bill_title1" style="padding-bottom: 15px">其他项结算合计
                <!-- <el-button v-if="currenindex !== 1 && !isLook"
                    size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem('smallVolumeSummarys')">
                    <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                    添加
                </el-button> -->
            </div>
            <vxe-table key="table4" ref="table4" border show-footer show-overflow align="center"
                :data="billData.smallVolumeSummarys" :row-config="{ isHover: true }" :column-config="{ resizable: true }"
                :scroll-y="{ enabled: true }" :footer-method="footerMethod3">
                <vxe-column field="product" title="产品名称">
                </vxe-column>
                <vxe-column field="amount" title="数量(m³)">
                </vxe-column>
                <vxe-column v-if="currenindex !== 4" field="basicPrice" title="基本单价(元/m³)">
                </vxe-column>
                <vxe-column v-if="currenindex !== 4" field="settlePrice" title="结算单价(元/m³)">
                </vxe-column>
                <vxe-column v-if="currenindex !== 4" field="totalMoney" title="结算额(元)">
                </vxe-column>
            </vxe-table>
            <!-- 调价结算 -->
            <div v-if="currenindex == 3" class="table5">
                <div class="bill_title1" style="padding-bottom: 15px"> 调整明细
                    <el-button v-if="!isLook" size="mini" class="bottom_all" style="margin-left: 24px"
                        @click="addItem('adjustDetailList')">
                        <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                        添加
                    </el-button>
                </div>
                <vxe-table key="table7" ref="table7" border show-footer show-overflow align="center"
                    :data="billData.adjustDetailList" :row-config="{ isHover: true }" :column-config="{ resizable: true }"
                    :scroll-y="{ enabled: true }" :header-cell-class-name="table5HeaderClass">

                    <vxe-column field="sex" title="调价时间段" width="400">
                        <template #default="{ row, rowIndex }">
                            <el-date-picker v-model="row.timeSlot" style="width:380px" value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange" :default-time="['00:00:00', '23:59:59']" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" @change="e => changeTimeSlot2(e, rowIndex)">
                            </el-date-picker>
                        </template>
                    </vxe-column>
                    <vxe-column field="stationName" title="调整类型" width="150">
                        <template #default="{ row }">
                            <el-select v-model="row.adjustTypeId" style="width: 120px" :disabled="isLook"
                                placeholder="请选择站点">
                                <el-option v-for="item in adjustTypeConfirmList" :key="item.id" :label="item.itemName"
                                    :value="item.id" @click.native="row.adjustType = item.itemName"></el-option>
                            </el-select>
                        </template>
                    </vxe-column>
                    <vxe-column field="product" title="产品名称">
                        <template #default="{ row }">
                            <el-input v-model="row.product" placeholder="请输入" :disabled="isLook"
                                style="width: 100%"></el-input>
                        </template>
                    </vxe-column>
                    <vxe-column field="adjustNum" title="数量(m³)">
                        <template #default="{ row }">
                            <el-input v-model="row.adjustNum" placeholder="请输入" :disabled="isLook" style="width: 100%"
                                onkeypress="return(/[0-9\.\-]/.test(String.fromCharCode(event.keyCode)))"
                                @input="row.adjustNum = $regExp.checkNum3(row.adjustNum)"
                                @blur="row.adjustNum = $regExp.blurCheckNum(row.adjustNum, true)"></el-input>
                        </template>
                    </vxe-column>
                    <vxe-column field="adjustMoney" title="金额">
                        <template #default="{ row }">
                            <el-input v-model="row.adjustMoney" placeholder="请输入" :disabled="isLook" style="width: 100%"
                                onkeypress="return( /[0-9\.\-]/.test(String.fromCharCode(event.keyCode)))"
                                @input="row.adjustMoney = $regExp.checkNum3(row.adjustMoney)"
                                @blur="row.adjustMoney = $regExp.blurCheckNum(row.adjustMoney, true)"></el-input>
                        </template>
                    </vxe-column>
                    <vxe-column field="remark" title="备注">
                        <template #default="{ row }">
                            <el-input v-model="row.remark" placeholder="请输入" :disabled="isLook"
                                style="width: 100%"></el-input>
                        </template>
                    </vxe-column>
                    <vxe-column v-if="!isLook" field="" title="操作">
                        <template #default="{ rowIndex }">
                            <el-button size="mini" class="bottom_two" @click="delItem(rowIndex, 'adjustDetailList')">
                                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                                删除
                            </el-button>
                        </template>
                    </vxe-column>
                </vxe-table>
            </div>
            <div v-if="currenindex !== 4" class="bill_title1" style="padding-bottom: 15px">结算合计</div>
            <vxe-table v-if="currenindex !== 4 && cycleId !== 1" key="table6" ref="table6" border show-overflow
                align="center" :data="billData.totalList" :row-config="{ isHover: true }"
                :column-config="{ resizable: true }" :scroll-y="{ enabled: true }">
                <vxe-column field="planMaterialAmount" title="应收甲供材料(T)" width="150">
                    <template #default="{ row }">
                        <el-input v-model="row.planMaterialAmount" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                            @input="row.planMaterialAmount = $regExp.checkNum(row.planMaterialAmount)"
                            @blur="row.planMaterialAmount = $regExp.blurCheckNum(row.planMaterialAmount)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="receiveMaterialAmount" title="已收甲供材料(T)">
                    <template #default="{ row }">
                        <el-input v-model="row.receiveMaterialAmount" placeholder="请输入" :disabled="isLook"
                            style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                            @input="row.receiveMaterialAmount = $regExp.checkNum(row.receiveMaterialAmount)"
                            @blur="row.receiveMaterialAmount = $regExp.blurCheckNum(row.receiveMaterialAmount)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="measuresRatioId" title="措施费比例">
                    <template #default="{ row }">
                        <el-select v-model="row.measuresRatioId" style="width: 120px" :disabled="isLook"
                            placeholder="请选择站点">
                            <el-option v-for="item in measuresRatioList" :key="item.itemValue" :label="item.itemName"
                                :value="item.itemValue" @click.native="row.measuresRatio = item.itemName"></el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column field="whetherAdjustPrice" title="是否含调价">
                    <template #default="{ row }">
                        <el-radio-group v-model="row.whetherAdjustPrice">
                            <el-radio :label="0" :disabled="isLook">否</el-radio>
                            <el-radio :label="1" :disabled="isLook">是</el-radio>
                        </el-radio-group>
                    </template>
                </vxe-column>
            </vxe-table>
            <vxe-table v-if="currenindex !== 4" key="table5" ref="table5" border show-overflow align="center"
                :data="billData.totalList" :row-config="{ isHover: true }" :column-config="{ resizable: true }"
                :scroll-y="{ enabled: true }">
                <vxe-column field="settleAmount" title="本次结算量(m3)" width="150">
                </vxe-column>
                <vxe-column field="cumulativeSettleAmount" title="累计结算量(m3)" width="150">
                </vxe-column>
                <vxe-column field="measuresCost" title="采购措施费" width="150">
                </vxe-column>
                <vxe-column field="summaryMoney" title="汇总金额（元)" width="150">
                </vxe-column>
                <vxe-column field="cumulativeSettleMoney" title="累计结算金额（元)" width="150">
                </vxe-column>
                <vxe-column field="settleMoney" title="结算金额" width="150">
                </vxe-column>
                <vxe-column field="cumulativeMouthAmount" title="累计月报量" width="150">
                </vxe-column>
                <vxe-column field="cumulativeMouthMoney" title="累计月报产值" width="150">
                </vxe-column>
                <vxe-column field="planInvoiceMoney" title="已开发票额(元)" width="150">
                    <template #default="{ row }">
                        <el-input v-model="row.planInvoiceMoney" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                            @input="row.planInvoiceMoney = $regExp.checkNum(row.planInvoiceMoney)"
                            @blur="row.planInvoiceMoney = $regExp.blurCheckNum(row.planInvoiceMoney)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="settleInvoiceMoney" title="已收款额(元)" width="150">
                    <template #default="{ row }">
                        <el-input v-model="row.settleInvoiceMoney" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                            @input="row.settleInvoiceMoney = $regExp.checkNum(row.settleInvoiceMoney)"
                            @blur="row.settleInvoiceMoney = $regExp.blurCheckNum(row.settleInvoiceMoney)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="loanArrearsMoney" title="已结算货款尚欠金额(元)" width="150">
                    <template #default="{ row }">
                        <el-input v-model="row.loanArrearsMoney" placeholder="请输入" :disabled="isLook" style="width: 100%"
                            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                            @input="row.loanArrearsMoney = $regExp.checkNum(row.loanArrearsMoney)"
                            @blur="row.loanArrearsMoney = $regExp.blurCheckNum(row.loanArrearsMoney)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="planMaterialAmount" title="应收甲供材料(T)" width="150">
                </vxe-column>
                <vxe-column field="receiveMaterialAmount" title="已收甲供材料(T)" width="150">
                </vxe-column>
            </vxe-table>
            <div>
                <div class="bill_title1" style="padding-bottom: 15px"> 撤回原因</div>
                <el-row style="padding-bottom: 15px">
                    <el-col :span="24">
                        <el-input v-model="billData.totalList[0].rejectReason" type="textarea" :rows="3"
                            placeholder="请输入内容">
                        </el-input>
                    </el-col>
                </el-row>
            </div>
            <div class="bill_title1" style="padding-bottom: 15px">备注</div>
            <el-row>
                <el-col :span="24">
                    <el-input v-model="billData.totalList[0].remark" :disabled="isLook" type="textarea" :rows="3"
                        placeholder="请输入内容">
                    </el-input>
                </el-col>
            </el-row>

            <div class="bill_title1" style="padding-bottom: 15px"> 事项说明</div>
            <el-row style="padding-bottom: 15px">
                <el-col :span="24">
                    <el-input v-model="billData.totalList[0].eventExplain" :disabled="isLook" type="textarea" :rows="3"
                        placeholder="请输入内容">
                    </el-input>
                </el-col>
            </el-row>
            <div v-if="currenindex == 2">
                <span class="bill_title">印章类型</span>
                <span style="margin-left: 24px;">
                    <el-select v-if="cycleId !== 1" v-model="billData.totalList[0].sealTypeId" style="width: 120px"
                        :disabled="isLook" placeholder="请选择">
                        <el-option v-for="item in sealTypeList" :key="item.id" :label="item.itemName" :value="item.id"
                            @click.native="billData.totalList[0].sealTypeName = item.itemName"></el-option>
                    </el-select>
                    <el-row v-if="cycleId == 1" style="padding:15px 0px">
                        <el-col :span="12">
                            <el-input v-model="billData.totalList[0].sealTypeName" :disabled="isLook" type="textarea"
                                :rows="1" placeholder="无">
                            </el-input>
                        </el-col>
                    </el-row>
                </span>
            </div>
            <div v-if="currenindex !== 1">
                <div class="bill_title">合同附件</div>
                <div v-for="(item, index) in disClostDetail.fileFist" :key="index" style="color:#00b85c">
                    <el-link type="sucess" :underline="false" @click="lookFileDetail2(item)">{{
                        item.fileName }}</el-link>
                    <a class="el-link" @click="lookFile2(item)">
                        <i class="el-icon-download" style="padding:0 10px"></i>
                    </a>
                </div>
            </div>
            <div v-if="currenindex == 3">
                <div class="bill_title">内审附件</div>
                <div v-for="(item, index) in insideFiles" :key="index" style="color:#00b85c">
                    <el-link type="sucess" :underline="false" @click="lookFileDetail2(item)">{{
                        item.fileName }}</el-link>
                    <a class="el-link" @click="lookFile2(item)">
                        <i class="el-icon-download" style="padding:0 10px"></i>
                    </a>
                </div>
            </div>
            <div v-if="currenindex !== 1" class="bill_title1" style="padding-bottom: 15px">{{ currenindex == 2 ? '内审附件' :
                currenindex == 3 ?
                    '返回附件' : '附件' }}</div>
            <FileComponent v-if="currenindex !== 1" fileCode="settlementFile" :disabled="isLook" :files="files"
                @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
            <!--  -->
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!isSure && currenindex !== 4 && !subMit && !isBack" class="bottom_all"
                    @click="exportSettle(2)">导出</el-button>
                <el-button
                    v-if="!isSure && currenindex !== 4 && !subMit && !isBack && billData.totalList[0].processManagerId"
                    class="bottom_all" @click="exportSettle(1)">导出(流转详情)</el-button>
                <el-button class="bottom_all_two" @click="(billDig = false)">取 消</el-button>
                <el-button v-if="isSure && !subMit && !isBack && (currenindex == 3 ? cycleId != 1 : true)"
                    class="bottom_all" style="margin-left: 24px" @click="saveBillData">保
                    存</el-button>
                <el-button
                    v-if="currenindex == 2 ? (subMit && cycleId != 1) : (subMit && low.masterProjectOrNot == 1 && cycleId != 1)"
                    class="bottom_all" style="margin-left: 24px" @click="saveBillData">提 交</el-button>
                <el-button v-if="isBack" class="bottom_all" style="margin-left: 24px" @click="saveBillData">撤 回</el-button>
                <el-button v-if="isSure && low.masterProjectOrNot == 1 && this.currenindex == 2" class="bottom_all"
                    style="margin-left: 24px" @click="openEngBind(false)">确 定</el-button>
            </span>
            <div v-if="low.masterProjectOrNot != 1 && currenindex !== 4" style="color:red;text-align: center;">
                该工程为子工程，不能提交审核！！</div>

        </el-dialog>
        <!-- 月报量确认报表查看 /过程核定量确认结算 -->
        <el-dialog :visible.sync="monthReportBillDig" width="1180px" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">混凝土结算</span>
            <div class="bill_top">
                <span><span class="text">工程名称：</span>{{ low.engineeringName }}</span>
                <span style="margin-left:24px"><span class="text">结算月份：</span>{{ low.settleMouth }}</span>
                <span style="margin-left:24px"><span class="text">结算时间段：</span>{{ low.lastDueTime }}至{{ low.currentDueTime
                }}</span>
            </div>
            <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                    <span style="margin-right: 12px">送货时间</span>
                    <el-date-picker v-model="monthReportBillParams.sendTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择日期" style="width: 120px;" @change="queryProductData()">
                    </el-date-picker>
                </span>
                <span style="margin-left: 24px;">
                    <span style="margin-right: 12px;">浇筑部位</span>
                    <el-input v-model="monthReportBillParams.pourPart" style="width: 120px;" placeholder="请输入"
                        @keyup.enter.native="queryProductData()" />
                </span>
                <span style="margin-left: 24px;">
                    <span style="margin-right: 12px;">砼强度</span>
                    <el-input v-model="monthReportBillParams.productName" style="width: 120px;" placeholder="请输入"
                        @keyup.enter.native="queryProductData()" />
                </span>
                <span style="margin-left: 24px;">
                    <span style="margin-right: 12px;">浇筑方式</span>
                    <el-input v-model="monthReportBillParams.pourMethod" style="width: 120px;" placeholder="请输入"
                        @keyup.enter.native="queryProductData()" />
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="queryProductData()">查
                    询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            </div>
            <vxe-table ref="table1" v-loading="monthReportBillLoading" border show-footer show-overflow height="600"
                align="center" :data="monthReportBillData" :row-config="{ isHover: true }"
                :column-config="{ resizable: true }" :scroll-y="{ enabled: true }">
                <vxe-column field="stationName" title="站点信息" width="100">
                </vxe-column>
                <vxe-column field="sendTime" title="送货时间" width="100">
                </vxe-column>
                <vxe-column field="pourPart" title="浇筑部位" width="150">
                </vxe-column>
                <vxe-column field="productName" title="产品名称" width="100">
                </vxe-column>
                <vxe-column field="customerSignNum" title="客户签收量(m³)" width="120" :formatter="formatAmount">
                </vxe-column>
                <vxe-column field="sureNum" title="双方确认砼量(m³)" width="150" :formatter="formatAmount">
                </vxe-column>
                <vxe-column field="pumpNum" title="泵送结算量(m³)" width="120" :formatter="formatAmount">
                </vxe-column>
                <vxe-column field="smallVolume" title="小方量补方(m³)" width="120" :formatter="formatAmount">
                </vxe-column>
                <vxe-column title="超高层" width="170">
                    <vxe-column field="superHighLevel" title="米数" width="70" :formatter="formatAmount">
                    </vxe-column>
                    <vxe-column field="superHighLevelNum" title="方量(m³)" width="80" :formatter="formatAmount">
                    </vxe-column>
                </vxe-column>
                <vxe-column field="pourMethod" title="浇筑方式" width="100">
                </vxe-column>
            </vxe-table>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="(monthReportBillDig = false)">取 消</el-button>
                <el-button v-if="isSure" class="bottom_all" style="margin-left: 24px"
                    @click="saveBillData">保存结算单</el-button>
            </span>
        </el-dialog>
        <!-- 生成结算 -->
        <el-dialog :visible.sync="monthReportBillAddDig" top="15vh" width="560px" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">生成结算</span>
            <el-form ref="monthReportBillForm" :model="monthReportBillForm" :rules="monthReportBillRules"
                label-width="80px">
                <el-form-item label="结算月份" prop="settleMouth">
                    <el-input-number v-model="monthReportBillForm.settleMouth" :precision="0" :controls="false" :min="1"
                        :max="12"></el-input-number>
                </el-form-item>
                <el-form-item label="生效日期" prop="dueTime">
                    <el-date-picker v-model="monthReportBillForm.dueTime" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="monthReportBillAddDig = false">关 闭</el-button>
                <el-button class="bottom_all_two" style="margin-left: 24px" @click="monthReportBillAddSave">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 附件查看 -->
        <el-dialog :visible.sync="fileDig" top="15vh" width="560px" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">附件</span>
            <div>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    :height="screenHeight / 2 - 100" style="width: 100%" :data="fileTableData" tooltip-effect="dark">
                    <el-table-column label="文件名称" prop="fileName" align="center">
                        <template slot-scope="scope">
                            <span>
                                <el-link type="sucess" :underline="false" @click="lookFileDetail(scope.row)">{{
                                    scope.row.fileName }}</el-link>
                                <a class="el-link" @click="lookFile2(scope.row)">
                                    <i class="el-icon-download" style="padding:0 10px"></i>
                                </a>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="closeFile">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 核对明细单弹窗 -->
        <checkDetail :visible.sync="checkDetailDig" :checkDetailType="checkDetailType" :centerRow="low"
            :stationIdlist="stationIdlist" :isLook="checkDetailLook" :disClostDetail="disClostDetail" :cycleId="cycleId"
            :bindEngList="bindEngList" @resetCheckDetail="checkDetailDig = false" />
        <!-- 核对明细单弹窗 -->
        <engBind :visible.sync="engBindDig" :isLook="engBindIsLook" :engBindMainId="low.id"
            :childCycles="billData.childCycles" @resetEngBind="engBindDig = false" @changeBindEng="changeBindEng" />
        <!-- 导出 -->
        <settleExport :visible.sync="exportDig" :exportForm="exportForm" :isNode="isNode" />
        <!-- 工程调价 -->
        <diaLog1 :dialog="dialog1" :isLook="true" :low="dialog1Low" @reset="reset"></diaLog1>
        <!-- 标号信息价 -->
        <priceMaintenance :visible.sync="priceMaintenanceDig" @reset="priceMaintenanceDig = false"></priceMaintenance>

    </div>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage } from "@/api/internetSales/monthlyReportUnitRecord.js";
import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import checkDetail from "./checkDetail.vue";
import engBind from "./engBind.vue";
import settleExport from "./settleExport.vue";
import priceMaintenance from "./priceMaintenance.vue";
import { queryMouthPage, queryInternalAuditPage, querySurePage, queryProductData, getStationByCompanyId, saveProductData, queryInternalSettleData, queryConfirmSettleData, submitExamineInternal, submitExamineConfirm, updaetSettleStatus, addCycle, deleteCycle, getDisClostDetail, querySummaryDataInternal, querySummaryDataConfirm, deleteSettleStatus, engProcessCycleQuery, engProcessCycleAdd, engCycleProductData, engCycleProductDataSave, querySummaryDataProcess, submitExamineProcess, queryProcessSettleData, deleteSettleProcess, deleteCycleProcess, queryChildEngCycles, queryRelevanceCycles, querySettleInitDataByCycleManageId, querySettleDataTotal, querySettleDataTotalConfirm, updateTotalRemarkInternal, updateTotalRemarkConfirm, confirmTotalDeleteData, internalTotalDownload as Download } from "@/api/wise/settlementTask.js";
import { getUserInfo } from "@/utils/auth.js";
import { _debounce } from '@/utils/utils.js'
import { getDicType } from '@/api/common';
import { getNodeList } from '@/api/task/flows';
const diaLog1 = () => import("@/views/platform/ICPS/internetSales/dialog/engineeringControl1");
export default {
    components: { FileComponent, checkDetail, diaLog1, priceMaintenance, settleExport, engBind },
    mixins: [mixin],
    data() {
        return {
            UserInfo: "",
            tableParamType: false,
            /*表格增删改查及下载接口*/
            queryPage: queryPage,
            DownloadURL: Download,
            pagesType: 0,
            mouthReportStatusList: [
                { name: "待确认", id: 0 },
                { name: "已确认", id: 1 },
            ],
            currenindex: 1,
            typelist: [
                {
                    value: "月报量",
                    status: 1,
                },
                {
                    value: "内审量",
                    status: 2,
                },
                {
                    value: "确认量",
                    status: 3,
                },
                {
                    value: "过程核定量",
                    status: 4,
                },
            ],
            settleItemList: [
                {
                    name: "图算结算单",
                    id: 1,
                },
                {
                    name: "票结结算单",
                    id: 2,
                },
            ],
            params: {},
            billDig: false,
            billData: {
                productSummarys: [],
                differSummarys: [],
                pumpSummarys: [],
                additional: [],
                smallVolumeSummarys: [],
                adjustDetailList: [],
                totalList: [
                    {
                        remark: "",
                        eventExplain: "",
                        rejectReason: "",
                    }
                ],
                deadlineDate: "",
            },
            low: {},
            pickerOptions: {
                disabledDate: this.disabledDate,
            },
            stationIdlist: [],
            disClostDetail: {},
            isLook: false,
            isSure: false,
            isAll: false,
            files: [],
            insideFiles: [],
            fileTableData: [],
            fileDig: false,
            monthReportBillData: [],
            monthReportBillDig: false,
            monthReportBillLoading: false,
            monthReportBillParams: {
                cycleManageId: "",
                cycleProcessManageId: "",
                sendTime: "",
                pourPart: "",
                productName: "",
                pourMethod: ""
            },
            monthReportBillAddDig: false,
            monthReportBillForm: {
                engineeringId: "",
                lastDueTime: "",
                currentDueTime: "",
                settleMouth: "",
                dueTime: [],
            },
            monthReportBillRules: {
                settleMouth: [
                    { required: true, message: '请输入结算月份', trigger: 'blur' },
                ],
                dueTime: [{ required: true, message: '请选择生效日期', trigger: 'change' },]
            },
            checkDetailDig: false,
            checkDetailType: 2,
            adjustTypeList: [],
            adjustTypeConfirmList: [],
            measuresRatioList: [],
            dialog1: false,
            priceMaintenanceDig: false,
            dialog1Low: {},
            oldTotal: {},
            checkDetailLook: false,
            exportForm: {},
            exportDig: false,
            isNode: 1,
            sealTypeList: [],
            cycleId: "",
            bindEngList: [],
            engBindDig: false,
            engBindIsLook: false,
            mainRow: {},
            subMit: false,
            isBack: false,
            initialData: {},
            generateSettlementVisible: false,
            generateSettlementType: 1,
        };
    },
    async created() {
        this.params = JSON.parse(this.$route.query.row);
        this.UserInfo = await getUserInfo();
        this.tableParam = this.$options.data().tableParam
        this.tableParam.engineeringId = this.params.engineeringId
        this.gettableDataNew();
        getDicType({ code: 'adjustmentTypeSettlement' }).then(res => {
            this.adjustTypeList = res.data.items;
        });
        getDicType({ code: 'adjustmentTypeConfirmSettlement' }).then(res => {
            this.adjustTypeConfirmList = res.data.items;
        });
        getDicType({ code: 'measuresRatio' }).then(res => {
            this.measuresRatioList = res.data.items;
        });
        getDicType({ code: 'sealType' }).then(res => {
            this.sealTypeList = res.data.items;
        });
    },
    watch: {
        billData: {
            handler() {
                this.settotalList()
            },
            deep: true,
            immediate: false,
        },
    },

    methods: {
        downLoad() {
            let params = {
                id: this.cycleId == 1 ? this.mainRow.id : this.cycleId,
                dataType: this.cycleId == 1 ? 2 : 1,
            }
            this.$Download(this.DownloadURL, params);
        },
        //确认量 重置
        goback(row) {
            this.$confirm("此操作将删除该信息?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "bottom_all_two",
                confirmButtonClass: "bottom_all",
                type: "warning",
            })
                .then(() => {
                    let data = { id: row.id };
                    confirmTotalDeleteData(data).then(res => {
                        if (res.code == 1001) {
                            this.gettableDataNew();
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        changeEng(item, isChild, isAll) {
            let row = item
            if (isChild) {
                row = {
                    engineeringName: item.engineeringName,
                    engineeringId: item.engineeringId,
                    lastDueTime: item.lastDueTime,
                    currentDueTime: item.currentDueTime,
                    id: item.childCycleId,
                }
            }
            let look = false
            if (this.currenindex == 3 && (this.mainRow.sureSelletesStatus == 0 || this.mainRow.sureSelletesStatus == 3 || this.mainRow.sureSelletesStatus == 5)) {
                look = true
            }
            this.billOpen(row, look, isChild, this.subMit, isAll)
        },
        changeBindEng(val) {
            this.billData.childCycles = val
            this.engBindDig = false
        },
        openEngBind(look) {
            let isNull = false
            this.billData.productSummarys.forEach(item => {
                if (!item.basicPrice && item.basicPrice != 0) {
                    isNull = true
                }
            })
            if (isNull) {
                this.$message.warning('产品列表基本单价不能为空!')
                return
            }
            this.engBindIsLook = look
            this.engBindDig = true

        },
        lookFileDetail2(row) {
            if (row.path.endsWith('.jpg') || row.path.endsWith('.png') || row.path.endsWith('.jpeg')) {
                let imgUrl = 'https://lvshe.huashijc.com/file/' + row.path;
                window.open(imgUrl, "_blank");
            } else {
                this.$wps(row.path);
            }
        },
        lookFile2(row) {
            let imgUrl = 'https://lvshe.huashijc.com/file/' + row.path;
            window.open(imgUrl, "_blank");
        },
        exportSettle(isNode) {
            this.isNode = isNode
            // const params = {
            //     processManagerId: '493563024230191104',
            //     processTaskId: '530100195871035392',
            //     processVersionId: '54d243f4184f4d75a1b0d6efcd45512a',
            // }
            //乙方公司
            this.exportForm['partyB'] = this.disClostDetail.collaborationUnitName
            //甲方公司
            this.exportForm['partyA'] = this.disClostDetail.roadworkType == 1 ? this.disClostDetail.constructionUnit : this.disClostDetail.constructionCompany
            if (isNode == 1) {
                const params = {
                    processManagerId: this.billData.totalList[0].processManagerId,
                    processTaskId: this.billData.totalList[0].processTaskId,
                    processVersionId: this.billData.totalList[0].processVersionId,
                }
                getNodeList(params).then(res => {
                    const newData = [];
                    const applyTypeList = ['-', '依次审批', '会签', '或签']
                    const flowsStatus = ['未审批', '待处理', '审批通过', '审批不通过', '发起人已撤销']
                    res.data.forEach((item, index) => {
                        let approvalOptions = ""
                        let handlerTime = ""
                        let approvalStatus = ""
                        let userName = item.instanceLogsList.map(sItem => sItem.userName)
                        if (item.nodeName == '抄送节点') {
                            approvalOptions = '-'
                            handlerTime = '-'
                            approvalStatus = userName ? '抄送' : '未抄送'
                        } else {
                            approvalOptions = item.instanceLogsList.map(sItem => sItem.approvalOptions)
                            handlerTime = item.instanceLogsList.map(sItem => sItem.handlerTime)
                            approvalStatus = index == 0 ? '-' : flowsStatus[item.approvalStatus]
                        }
                        const data = {
                            nodeName: item.nodeName,
                            userName: userName,
                            multiApprovalType: item.nodeName == '抄送节点' ? '-' : applyTypeList[item.multiApprovalType],
                            approvalOptions: approvalOptions,
                            handlerTime: handlerTime,
                            approvalStatus: approvalStatus,
                        }
                        newData.push(data);
                    });
                    const result = newData.reduce((acc, item) => {
                        acc.nodeName += (acc.nodeName ? '*' : '') + item.nodeName;
                        acc.userName += (acc.userName ? '*' : '') + item.userName;
                        acc.multiApprovalType += (acc.multiApprovalType ? '*' : '') + item.multiApprovalType;
                        acc.approvalOptions += (acc.approvalOptions ? '*' : '') + item.approvalOptions;
                        acc.handlerTime += (acc.handlerTime ? '*' : '') + item.handlerTime;
                        acc.approvalStatus += (acc.approvalStatus ? '*' : '') + item.approvalStatus;
                        return acc;
                    }, { nodeName: '', userName: '', multiApprovalType: '', approvalOptions: '', handlerTime: '', approvalStatus: '' });

                    console.log(result);
                    this.exportForm = { ...this.exportForm, ...result }
                    this.exportDig = true
                })
            } else {
                this.exportDig = true
            }
        },
        table5HeaderClass({ column }) {
            if (column.field === 'remark') {
                return 'redHead'
            }
            return null
        },
        formatAmount(row) {
            // 格式化数字，保留两位小数
            return row.cellValue ? row.cellValue.toFixed(2) : '0.00';
        },
        LookcheckDetail() {
            this.checkDetailType = this.currenindex
            this.checkDetailLook = this.isLook
            if (this.currenindex == 3) {
                this.checkDetailLook = true
            }
            this.checkDetailDig = true
        },
        lookDialog1() {
            this.dialog1Low = {
                id: this.low.engineeringId
            }
            this.dialog1 = true
        },
        reset(key) {
            this[key] = false;
        },
        //生成结算
        generateSettlement() {
            let _this = this
            this.$nextTick(() => {
                // const queryMethod = this.currenindex == 2 ? querySummaryDataInternal : this.currenindex ==3 ? querySummaryDataConfirm :querySummaryDataProcess
                let queryMethod;
                switch (this.currenindex) {
                    case 2:
                        queryMethod = querySummaryDataInternal;
                        break;
                    case 3:
                        queryMethod = querySummaryDataConfirm;
                        break;
                    case 4:
                        queryMethod = querySummaryDataProcess;
                        break;
                }
                queryMethod(
                    {
                        id: this.low.id,
                        ...(this.currenindex === 2 && { settleMethod: this.generateSettlementType })
                    }
                ).then(res => {
                    if (res.code == 1001) {
                        if (res.data.promptInformation) {
                            res.data.promptInformation = res.data.promptInformation.replace(/\n/g, '<br>');
                            this.$message.warning({
                                message: res.data.promptInformation,
                                dangerouslyUseHTMLString: true
                            })
                        }
                        let totalItem =
                        {
                            settleMoney: 0,
                            planMaterialAmount: 0,
                            receiveMaterialAmount: 0,
                            settleAmount: 0,
                            cumulativeSettleAmount: 0,
                            measuresCost: 0,
                            summaryMoney: 0,
                            cumulativeSettleMoney: 0,
                            measuresRatio: "无",
                            measuresRatioId: 0,
                            whetherAdjustPrice: 0,
                            planInvoiceMoney: res.data.planInvoiceMoney,
                            settleInvoiceMoney: res.data.settleInvoiceMoney,
                            loanArrearsMoney: 0,
                            remark: "",
                            eventExplain: "",
                            rejectReason: "",
                            enclosureUrl: null,
                            deductionAmount: 1012,
                            marginAmount: 0,
                            processManagerId: "",
                            processTaskId: "",
                            processVersionId: "",
                            cumulativeMouthAmount: 0,
                            cumulativeMouthMoney: 0,
                            sealTypeId: "",
                            sealTypeName: "",
                        }
                        this.oldTotal = res.data.auditTotal ? JSON.parse(JSON.stringify(res.data.auditTotal)) : JSON.parse(JSON.stringify(totalItem))
                        let billData = {
                            productSummarys: res.data.productSummarys,
                            differSummarys: res.data.differSummarys,
                            pumpSummarys: res.data.pumpSummarys,
                            additional: [],
                            smallVolumeSummarys: res.data.smallVolumeSummarys,
                            totalList: [res.data.auditTotal || totalItem],
                            auditTotal: res.data.auditTotal || totalItem,
                            auditDataList: res.data.auditDataList,
                            cycleId: res.data.cycleId || this.low.id,
                            currentTime: res.data.currentTime
                        }
                        if (this.currenindex == 4) {
                            billData['cycleProcessId'] = res.data.cycleProcessId
                            billData['settleMethod'] = res.data.settleMethod
                        }
                        billData.totalList[0].planInvoiceMoney = res.data.planInvoiceMoney
                        billData.totalList[0].settleInvoiceMoney = res.data.settleInvoiceMoney
                        billData.differSummarys?.forEach(item => {
                            if (item.startTime && item.endTime) {
                                item['timeSlot'] = [item.startTime, item.endTime]
                            }

                        })
                        let additional = []
                        billData.productSummarys?.forEach(item => {
                            if (item.additionalMaterial) {
                                let additionalMaterial = JSON.parse(item.additionalMaterial)
                                let additionalChird = additionalMaterial.map(item2 => item2.name)
                                additional = [...new Set([...additional, ...additionalChird])];
                            }
                            item['settleItem'] = res.data.settleMethod == 0 ? '' : res.data.settleMethod
                        })
                        _this.$set(_this, 'billData', billData)
                        _this.$set(_this.billData, 'additional', additional)
                        _this.billData.productSummarys?.forEach(item => {
                            let additionalMaterialArr = item.additionalMaterial ? JSON.parse(item.additionalMaterial) : []
                            _this.billData.additional.forEach(item2 => {
                                let obj = additionalMaterialArr.find(item3 => item3.name === item2)
                                item[item2] = obj ? Number(obj.price).toFixed(2) : '';
                            });
                        })
                        const targetKeywords = ['润泵砂浆', '洗泵水', '润泵水'];
                        _this.billData.pumpSummarys?.forEach(item => {
                            if (targetKeywords.some(key => item.product.includes(key))) {
                                item.amount = 0;
                            }
                        })
                        _this.billData.smallVolumeSummarys?.forEach(item => {
                            if (targetKeywords.some(key => item.product.includes(key))) {
                                item.amount = 0;
                            }
                        })
                        console.log(_this.billData)
                    }
                })
            });

        },
        disabledDate(time) {
            return time.getTime() > Date.now();
        },
        monthReportBillAddSave() {
            this.$refs['monthReportBillForm'].validate((valid) => {
                if (valid) {
                    if (this.monthReportBillForm.dueTime.length > 0) {
                        this.monthReportBillForm.lastDueTime = this.monthReportBillForm.dueTime[0]
                        this.monthReportBillForm.currentDueTime = this.monthReportBillForm.dueTime[1]
                    }
                    const addCycleMethod = this.currenindex == 1 ? addCycle : engProcessCycleAdd
                    addCycleMethod(this.monthReportBillForm).then(res => {
                        if (res.code == 1001) {
                            this.$message.success('保存成功!')
                            this.monthReportBillAddDig = false
                            this.gettableDataNew();
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        monthReportAdd() {
            this.monthReportBillForm = this.$options.data().monthReportBillForm
            this.monthReportBillForm.engineeringId = this.params.engineeringId
            this.monthReportBillAddDig = true
            setTimeout(() => {
                this.$refs['monthReportBillForm'].resetFields();
            }, 200)
        },
        closeFile() {
            this.fileDig = false
        },
        lookFileDetail(row) {
            if (row.path.endsWith('.jpg') || row.path.endsWith('.png') || row.path.endsWith('.jpeg')) {
                let imgUrl = 'https://lvshe.huashijc.com/file/' + row.path;
                window.open(imgUrl, "_blank");
            } else {
                this.$wps(row.path);
            }
        },
        lookFile(row) {
            let file = []
            // if (this.currenindex == 2) {
            //     if (!row.insideExamineEnclosureUrl) {
            //         this.$message.warning('暂无附件！')
            //         return
            //     }
            //     file = JSON.parse(row.insideExamineEnclosureUrl)
            // } else {
            //     if (!row.sureSelletesEnclosureUrl) {
            //         this.$message.warning('暂无附件！')
            //         return
            //     }
            //     
            // }
            if (!row.attachmentUrl) {
                this.$message.warning('暂无附件！')
                return
            }
            file = JSON.parse(row.attachmentUrl)
            this.fileTableData = file
            this.fileDig = true
        },
        handleFinish(row) {
            updaetSettleStatus({
                id: row.id,
                dataType: 2,
                settleStatus: 3,
            })
        },
        uplodeSuccess(data) {
            const params = {
                name: data.fileName,
                fileName: data.fileName,
                fileUrl: data.fileUrl,
                path: data.fileUrl,
                fileType: 1,
                type: 1,
                createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
            };
            this.files.push(params);
        },
        deleteFile(index) {
            this.files.splice(index, 1);
        },
        changeTimeSlot(value, rowIndex) {
            if (value.length > 0) {
                this.billData.differSummarys[rowIndex]['startTime'] = value[0]
                this.billData.differSummarys[rowIndex]['endTime'] = value[1]
            } else {
                this.billData.differSummarys[rowIndex]['startTime'] = ''
                this.billData.differSummarys[rowIndex]['endTime'] = ''
            }
        },
        changeTimeSlot2(value, rowIndex) {
            if (value.length > 0) {
                this.billData.adjustDetailList[rowIndex]['startTime'] = value[0]
                this.billData.adjustDetailList[rowIndex]['endTime'] = value[1]
            } else {
                this.billData.adjustDetailList[rowIndex]['startTime'] = ''
                this.billData.adjustDetailList[rowIndex]['endTime'] = ''
            }
        },
        sumNum(list, field) {
            let count = 0
            list.forEach(item => {
                count += Number(item[field])
            })
            // return field == 'amount' ? Number(count).toFixed(3) : Number(count).toFixed(2)
            return Number(count).toFixed(3)
        },
        sumNum1(list, field) {
            let count = 0
            const arr = ['洗泵水', '润泵水', '润泵砂浆'];
            list.forEach(item => {
                let result = arr.some(str => item['productName'].includes(str));
                if (!(field == 'amount' && result)) {
                    count += Number(item[field])
                }
            })
            // return field == 'amount' ? Number(count).toFixed(3) : Number(count).toFixed(2)
            return Number(count).toFixed(3)
        },
        footerMethod1({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '小计'
                    }
                    if (['amount', 'totalMoney'].includes(column.field)) {
                        return this.sumNum1(data, column.field)
                    }
                    return null
                }),
            ]
        },
        footerMethod2({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '小计'
                    }
                    if (['amount', 'differMoney'].includes(column.field)) {
                        return this.sumNum(data, column.field)
                    }
                    return null
                }),
            ]
        },
        footerMethod3({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '小计'
                    }
                    if (['amount', 'totalMoney'].includes(column.field)) {
                        return this.sumNum(data, column.field)
                    }
                    return null
                }),
            ]
        },
        additionalPrice(index, key, value) {
            this.$nextTick(() => {
                this.$set(this.billData.productSummarys[index], key, this.$regExp.checkNum(value))
                this.$refs.table1.loadData(this.billData.productSummarys)
            })
        },
        additionalPriceBlur(index, key) {
            this.$nextTick(() => {
                this.$set(this.billData.productSummarys[index], key, this.$regExp.blurCheckNum(this.billData.productSummarys[index][key]))
                this.$refs.table1.loadData(this.billData.productSummarys)
                this.settotalList()
            })
        },
        //月报量-保存
        saveBillData: _debounce(function () {
            if (this.currenindex == 1 || (this.currenindex == 4 && this.low.settleStatus == 0)) {
                const saveData = this.currenindex == 1 ? saveProductData : engCycleProductDataSave
                let params = {}
                params[this.currenindex == 1 ? 'cycleManageId' : 'cycleProcessManageId'] = this.low.id
                saveData(params).then(res => {
                    if (res.code == 1001) {
                        this.monthReportBillDig = false;
                        this.gettableDataNew();
                    }
                })
            }
            if (this.currenindex == 2 || this.currenindex == 3 || (this.currenindex == 4 && this.low.settleStatus !== 0)) {
                let billData = JSON.parse(JSON.stringify(this.billData))
                let params = JSON.parse(JSON.stringify(this.billData))
                // let isNull = false
                // params.productSummarys.forEach(item => {
                //     if (!item.basicPrice && item.basicPrice != 0) {
                //         isNull = true
                //     }
                // })
                // if (isNull) {
                //     this.$message.warning('产品列表基本单价不能为空!')
                //     return
                // }
                if (this.currenindex == 4) {
                    params['auditTotal'] = params.totalList[0]
                }
                let timeIsNull = false
                if (this.currenindex == 2) {
                    params['auditTotal'] = params.totalList[0]
                    params['differSummarys']?.forEach(item => {
                        if (!item.startTime) {
                            timeIsNull = true
                        }
                    })
                    if (timeIsNull) {
                        this.$message.warning('调价时间段不能为空!')
                        return
                    }
                }
                if (this.currenindex == 3) {
                    let remarkIsNull = false
                    params['adjustDetailList']?.forEach(item => {
                        if (!item.remark) {
                            remarkIsNull = true
                        }
                        if (!item.startTime) {
                            timeIsNull = true
                        }
                    })
                    if (remarkIsNull) {
                        this.$message.warning('调整明细备注不能为空!')
                        return
                    }
                    if (timeIsNull) {
                        this.$message.warning('调整明细时间段不能为空!')
                        return
                    }
                    if (this.low.id == this.mainRow.id) {
                        billData['settleStatus'] = 5
                        params['settleStatus'] = 5
                    } else {
                        billData['settleStatus'] = 4
                        params['settleStatus'] = 4
                    }
                }
                if (this.isBack && !params['auditTotal'].rejectReason) {
                    this.$message.warning('撤回原因不能为空!')
                    return
                }
                billData['engineeringName'] = this.low.engineeringName
                billData['engineeringId'] = this.low.engineeringId
                billData['lastDueTime'] = this.low.lastDueTime
                billData['endDueTime'] = this.low.currentDueTime
                billData['dataType'] = this.currenindex == 2 ? 1 : (this.currenindex == 3 ? 2 : 3)
                billData['cycleManageId'] = this.low.id
                billData['cycleProcessId'] = this.low.id
                billData['settlementTaskType'] = this.low.paymentMethodId
                params.auditTotal['enclosureUrl'] = JSON.stringify(this.files)
                billData['files'] = JSON.stringify(this.files)
                let updateBackRemarkMethod = this.currenindex == 2 ? updateTotalRemarkInternal : updateTotalRemarkConfirm
                let saveMethod;
                switch (this.currenindex) {
                    case 2:
                        saveMethod = submitExamineInternal;
                        break;
                    case 3:
                        saveMethod = submitExamineConfirm;
                        break;
                    case 4:
                        saveMethod = submitExamineProcess;
                        break;
                }
                if (this.subMit) {
                    this.$router.push({ name: "sign_settlementTask", query: { dataContent: JSON.stringify(billData), type: 1 } });
                } else if (this.isBack) {
                    updateBackRemarkMethod({
                        id: this.low.id,
                        remark: params['auditTotal'].rejectReason
                    }).then(res => {
                        if (res.code == 1001) {
                            this.$router.push({ name: "sign_settlementTask_back", query: { dataContent: JSON.stringify(billData), type: 1 } });
                        }
                    })
                } else {
                    saveMethod(params).then(res => {
                        if (res.code == 1001) {

                            if (this.currenindex == 3 && this.low.id != this.mainRow.id) {
                                this.billDig = true;
                            } else {
                                this.billDig = false;
                                this.gettableDataNew();
                            }
                            if (this.currenindex == 4) {
                                this.$router.push({ name: "sign_settlementTask", query: { dataContent: JSON.stringify(billData), type: 1 } });
                            }
                        }
                    })
                }

            }
        }, 500),
        //结算单 各个表格数据修改 合计
        settotalList: _debounce(function () {
            console.log(this.oldTotal)
            //产品表数据
            this.billData.productSummarys?.forEach((item) => {
                let otherPriceAll = 0
                let additionalMaterial = [];
                this.billData.additional.forEach(item2 => {
                    if (item[item2]) {
                        otherPriceAll = otherPriceAll + item[item2] * 1
                        additionalMaterial.push({
                            name: item2,
                            price: item[item2]
                        })

                    }

                });
                item.additionalMaterial = JSON.stringify(additionalMaterial)
                item.totalUnitPrice = Math.round(parseFloat(Number(item.basicPrice) + Number(otherPriceAll)) * 1000) / 1000
                item.totalMoney = Math.round(parseFloat(Number(item.amount) * Number(item.totalUnitPrice)) * 1000) / 1000
            })
            this.$refs.table1.reloadData(this.billData.productSummarys)
            //泵送
            this.billData.pumpSummarys?.forEach((item) => {
                item.totalMoney = Math.round(parseFloat(Number(item.amount || 0) * Number(item.settlePrice || 0)) * 1000) /
                    1000
            })
            this.$refs.table3.reloadData(this.billData.pumpSummarys)
            //其他
            this.billData.smallVolumeSummarys?.forEach((item) => {
                item.totalMoney = Math.round(parseFloat(Number(item.amount || 0) * Number(item.settlePrice || 0)) * 1000) /
                    1000
            })
            this.$refs.table4.reloadData(this.billData.smallVolumeSummarys)
            if (this.currenindex == 3) {
                //确认量调价
                this.billData.adjustDetailList?.forEach((item) => {
                    item.totalMoney = Math.round(parseFloat(Number(item.adjustNum || 0) * Number(item.adjustMoney || 0)) * 1000) /
                        1000
                })

                this.$refs.table7.reloadData(this.billData.adjustDetailList)
            }
            if (this.currenindex !== 4) {
                //调价数据
                this.billData.differSummarys?.forEach((item) => {
                    item.differMoney = Math.round(parseFloat(Number(item.amount || 0) * Number(item.differPrice || 0)) * 1000) /
                        1000
                })
                this.$refs.table2.reloadData(this.billData.differSummarys)
                //合计
                let sumAmount = 0;
                let adjustAmount = 0;
                let sumMoney = 0;
                let sumMoneyNoDiffer = 0; //不包含调价
                const updateSum = (list, amountKey, moneyKey, isProduct) => {
                    list?.forEach(item => {
                        if (isProduct) {
                            const arr = ['洗泵水', '润泵水', '润泵砂浆'];
                            let result = arr.some(str => item['productName'].includes(str));
                            if (!result) {
                                sumAmount += item[amountKey];
                            }
                        }
                        if (amountKey != 'adjustNum') {
                            sumMoney += item[moneyKey];
                        }
                        if (amountKey == 'adjustNum') {
                            sumAmount += item[amountKey];
                            adjustAmount += item[amountKey];
                        }
                        if (moneyKey !== 'differMoney') {
                            sumMoneyNoDiffer += item[moneyKey];
                        }
                    });
                };
                updateSum(this.billData.productSummarys, 'amount', 'totalMoney', true);
                updateSum(this.billData.differSummarys, 'amount', 'differMoney');
                updateSum(this.billData.pumpSummarys, 'amount', 'totalMoney');
                updateSum(this.billData.smallVolumeSummarys, 'amount', 'totalMoney');
                updateSum(this.billData.adjustDetailList, 'adjustNum', 'adjustMoney'); //调整金额直接当做总金额
                // let isSave = this.currenindex == 2 ? (this.mainRow.insideExamineSettlesStatus == 0 || this.mainRow.insideExamineSettlesStatus == 3 || this.mainRow.insideExamineSettlesStatus == 5) : this.currenindex == 3 ? (this.mainRow.sureSelletesStatus == 0 || this.mainRow.sureSelletesStatus == 3 || this.mainRow.sureSelletesStatus == 5) : false
                let isSave = this.currenindex == 2 ? (this.mainRow.insideExamineSettlesStatus == 0 || this.mainRow.insideExamineSettlesStatus == 3 || this.mainRow.insideExamineSettlesStatus == 5) : false
                let isAdjustSave = this.currenindex == 3 ? (this.mainRow.sureSelletesStatus == 0 || this.mainRow.sureSelletesStatus == 3 || this.mainRow.sureSelletesStatus == 5) : false
                console.log(this.isSure)
                console.log(isSave)
                this.billData.totalList.forEach(item => {
                    item['settleAmount'] = Number(sumAmount).toFixed(3);
                    console.log(this.oldTotal.cumulativeSettleAmount)
                    if (this.isSure && isSave) {
                        item['cumulativeSettleAmount'] = Number(this.initialData.settleInitAmount * 1 + item['settleAmount'] * 1).toFixed(3);
                    } else {
                        item['cumulativeSettleAmount'] = Number(this.oldTotal.cumulativeSettleAmount * 1).toFixed(3)
                    }
                    console.log(item['cumulativeSettleAmount'])
                    let measuresCost = 0
                    if (!this.isAll) {
                        if (item.whetherAdjustPrice == 0) { //不含调价
                            measuresCost = Number(sumMoneyNoDiffer * item.measuresRatioId * 1).toFixed(3)
                            item['settleMoney'] = Number(sumMoney * 1 - measuresCost * 1).toFixed(3);
                        } else { //含调价
                            measuresCost = Number(sumMoney * item.measuresRatioId * 1).toFixed(3)
                            item['settleMoney'] = Number(sumMoney * 1 - measuresCost * 1).toFixed(3);
                        }
                        item['measuresCost'] = Number(measuresCost).toFixed(3);
                        item['summaryMoney'] = Number(sumMoney).toFixed(3);
                        console.log('----------------------')
                        console.log(item['settleMoney'])
                        console.log(this.initialData.settleInitMoney)
                        console.log(this.oldTotal.cumulativeSettleMoney)
                        if (this.isSure && isSave) {
                            console.log('save')
                            item['cumulativeSettleMoney'] = Number(Math.round(parseFloat(Number(this.initialData.settleInitMoney) + Number(item['settleMoney'])) * 1000) / 1000).toFixed(3)
                        } else {
                            item['cumulativeSettleMoney'] = Number(this.oldTotal.cumulativeSettleMoney * 1).toFixed(3)
                        }
                        console.log(item['cumulativeSettleMoney'])
                        console.log('----------------------')
                        //调整明细金额不计入汇总金额 ，直接计入结算金额
                        if (this.currenindex == 3) {
                            const total = this.billData.adjustDetailList.reduce((sum, item) => {
                                return sum + (item.adjustMoney || 0);
                            }, 0)
                            item['settleMoney'] = Number(Math.round(parseFloat(Number(item['settleMoney']) + Number(total)) * 1000) / 1000).toFixed(3)
                            if (isAdjustSave) {
                                console.log('Adjust:', total)
                                item['cumulativeSettleMoney'] = Number(Math.round(parseFloat(Number(item['cumulativeSettleMoney']) + Number(total)) * 1000) / 1000).toFixed(3)
                                // item['cumulativeSettleAmount'] = Number(this.initialData.settleInitAmount * 1 + adjustAmount * 1).toFixed(3);
                                item['cumulativeSettleAmount'] = Number(this.oldTotal.cumulativeSettleAmount * 1 + adjustAmount * 1).toFixed(3);

                            }
                        }
                        item['loanArrearsMoney'] = item['settleInvoiceMoney'] * 1 - item['cumulativeSettleMoney']
                    }

                });
                this.billData.auditTotal = this.billData.totalList[0]
                this.$refs.table5.reloadData(this.billData.totalList)
            }



        }, 500),
        addItem(key) {
            if (key == 'productSummarys') {
                -
                    this.billData.productSummarys.push({
                        productName: "",//产品名称
                        amount: null,//产品数量
                        basicPrice: null,//基本单价（强度等级价格）
                        additionalMaterial: "",//附加材料，[{"name:"","price:""}]
                        totalUnitPrice: null,//总单价(基本单价+附加单价)
                        totalMoney: null,//总金额(总单价*总数量)
                        stationCode: "",//站点编码
                        stationName: "",//
                        stationId: "",//
                        settleItem: "",//结算项
                        detailVos: [],
                        sortKey: "",
                    })
            }
            if (key == 'differSummarys') {
                this.billData.differSummarys.push({
                    timeSlot: [],
                    adjustType: "",
                    adjustTypeId: "",
                    productName: "",//产品名称
                    startTime: "",
                    endTime: "",
                    amount: null,//产品数量
                    differPrice: null,//基本单价（强度等级价格）
                    differMoney: null,//总金额(总单价*总数量)
                    sortKey: "",
                    alreadySettlePrice: "",
                    newAdjustPrice: "",
                    remark: "",
                })
            }
            if (key == 'pumpSummarys') {
                this.billData.pumpSummarys.push({
                    stationName: "",//
                    stationId: "",//
                    stationCode: "",
                    pumpMethod: "",//产品名称
                    amount: null,//产品数量
                    basicPrice: null,//基本单价
                    settlePrice: null,//结算单价
                    totalMoney: null,//总金额(总单价*总数量)
                })
            }
            if (key == 'smallVolumeSummarys') {
                console.log('-----111------')
                this.billData.smallVolumeSummarys.push({
                    stationName: "",//
                    stationId: "",//
                    stationCode: "",
                    pumpMethod: "",//产品名称
                    amount: null,//产品数量
                    basicPrice: null,//基本单价
                    settlePrice: null,//结算单价
                    totalMoney: null,//总金额(总单价*总数量)
                })
                this.settotalList()
            }
            if (key == 'totalList') {
                this.billData.totalList.push({
                    settleAmount: 0,//本次结算量
                    settleMoney: 0,//本次结算金额
                    planMaterialAmount: '',//应收甲供材料（T）
                    receiveMaterialAmount: '',//已收甲供材料（T）
                    planInvoiceMoney: '',//已开发票额（元）
                    settleInvoiceMoney: '',//已收款额（元
                    loanArrearsMoney: '',//已结算货款尚欠金额
                })
                this.settotalList()
            }
            if (key == 'adjustDetailList') {
                this.billData.adjustDetailList.push({
                    startTime: "",//调整时间段-开始时间
                    endTime: "",//调整时间段-结束时间
                    adjustTypeId: "",//调整类型id,字典
                    adjustType: "",//
                    product: "",//产品名称
                    adjustNum: 0,//调整数量
                    adjustMoney: 0,//调整金额
                    remark: "",//备注信息
                    timeSlot: [],
                })
                this.settotalList()
            }

        },
        delItem(rowIndex, key) {
            this.billData[key].splice(rowIndex, 1)
            this.settotalList()
        },
        gettableDataNew() {
            const queryFunction = (query) => {
                query(this.tableParam).then(res => {
                    if (res.code == 1001) {
                        this.tableLoading = false;
                        this.total = res.data.totalRows;
                        this.tableData = res.data.data;
                    }
                });
            };

            if (this.currenindex == 1) {
                queryFunction(queryMouthPage);
            }
            if (this.currenindex == 2) {
                queryFunction(queryInternalAuditPage);
            }
            if (this.currenindex == 3) {
                queryFunction(querySurePage);
            }
            if (this.currenindex == 4) {
                queryFunction(engProcessCycleQuery);
            }
        },
        choose(num) {
            this.currenindex = num;
            this.tableParam = this.$options.data().tableParam
            this.tableParam.engineeringId = this.params.engineeringId
            this.gettableDataNew();
        },
        init() {
            /*重置数据*/
            this.monthReportBillParams.sendTime = "";
            this.monthReportBillParams.pourPart = "";
            this.monthReportBillParams.productName = "";
            this.monthReportBillParams.pourMethod = "";
            this.queryProductData();
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableDataNew();
        },
        queryProductData() {
            const getData = this.currenindex == 1 ? queryProductData : engCycleProductData
            getData(this.monthReportBillParams).then(res => {
                if (res.code == 1001) {
                    this.monthReportBillData = res.data
                }
                this.monthReportBillLoading = false
            })
        },
        //内审量删除
        deleteInsideBill(row) {
            this.$confirm("此操作将删除该信息?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "bottom_all_two",
                confirmButtonClass: "bottom_all",
                type: "warning",
            })
                .then(() => {
                    let data = { id: row.id };
                    deleteSettleStatus(data).then(res => {
                        if (res.code == 1001) {
                            this.gettableDataNew();
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        //过程核定量删除
        deleteProcess(row) {
            this.$confirm("此操作将删除该信息?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "bottom_all_two",
                confirmButtonClass: "bottom_all",
                type: "warning",
            })
                .then(() => {
                    let deleteMethod = row.settleStatus == 0 ? deleteCycleProcess : deleteSettleProcess
                    let data = { id: row.id };
                    deleteMethod(data).then(res => {
                        if (res.code == 1001) {
                            this.gettableDataNew();
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        //删除
        deleteBill(row) {
            this.$confirm("此操作将删除该信息?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "bottom_all_two",
                confirmButtonClass: "bottom_all",
                type: "warning",
            })
                .then(() => {
                    let data = { id: row.id };
                    deleteCycle(data).then(res => {
                        if (res.code == 1001) {
                            this.gettableDataNew();
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        //   去确认
        async billOpen(row, type, NoMainRow, subMit, isAll, isBack) {
            if (!NoMainRow) {
                this.mainRow = JSON.parse(JSON.stringify(row))
            }
            this.isLook = false
            this.isSure = type
            this.subMit = subMit
            this.isBack = isBack
            this.isAll = isAll
            this.low = JSON.parse(JSON.stringify(row))
            if (!isAll) {
                this.cycleId = this.low.id
            }

            this.exportForm = {
                engineeringName: this.low.engineeringName,
                lastDueTime: this.low.lastDueTime,
                currentDueTime: this.low.currentDueTime,
                cycleManageId: this.low.id,
                dataType: this.currenindex
            }
            getStationByCompanyId({ engineeringId: this.low.engineeringId }).then(res => {
                if (res.code == 1001) {
                    this.stationIdlist = res.data
                }
            })
            getDisClostDetail({ id: this.low.engineeringId }).then(res => {
                if (res.code == 1001) {
                    this.disClostDetail = res.data
                }
            })
            querySettleInitDataByCycleManageId({ id: this.low.id }).then(res => {
                if (res.code == 1001) {
                    if (
                        res.data &&
                        typeof res.data === 'object' &&
                        !Array.isArray(res.data) &&
                        Object.keys(res.data).length > 0
                    ) {
                        this.initialData = res.data
                    } else {
                        this.initialData = {
                            settleInitAmount: 0,
                            settleInitMoney: 0
                        }
                    }

                }
            })
            if (this.currenindex == 1 || (this.currenindex == 4 && row.settleStatus == 0)) {
                this.isLook = !type
                this.monthReportBillParams.cycleManageId = row.id
                this.monthReportBillParams.cycleProcessManageId = row.id
                this.monthReportBillLoading = true
                this.queryProductData()
                this.monthReportBillDig = true
                return
            }
            //过程核定量 待审核 审核不通过 审核 
            if (this.currenindex == 4 && (row.settleStatus == 1 || row.settleStatus == 3)) {
                this.billData = this.$options.data().billData
                this.billDig = true
                return
            }
            //主工程
            if (this.mainRow.masterProjectOrNot == 1 && this.currenindex == 2) {
                let res = await queryChildEngCycles({ id: this.mainRow.id })
                if (res.code == 1001) {
                    this.bindEngList = res.data
                    if (isAll) {
                        let ids = res.data.map(item => { return item.childCycleId })
                        ids.push(this.low.id)
                        this.exportForm.cycleManageId = ids.join("','")
                    }
                }
            }
            if (this.mainRow.masterProjectOrNot == 1 && this.currenindex == 3) {
                let res = await queryRelevanceCycles({ id: this.mainRow.id })
                if (res.code == 1001) {
                    this.bindEngList = res.data
                    this.bindEngList.forEach(item => {
                        item['childCycleId'] = item.id
                    });
                }
            }
            if ((this.currenindex == 2 && row.insideExamineSettlesStatus !== 0) || (this.currenindex == 3) || (this.currenindex == 4 && (row.settleStatus == 2 || row.settleStatus == 4))) {
                this.files = []
                if (this.low.insideExamineEnclosureUrl) {
                    this.files = JSON.parse(this.low.insideExamineEnclosureUrl)
                }
                this.isLook = !type
                if (isAll) {
                    const querySettleDataTotalMethod = this.currenindex == 2 ? querySettleDataTotal : querySettleDataTotalConfirm
                    querySettleDataTotalMethod({ id: this.low.id, childEngineeringList: this.bindEngList }).then(res => {
                        if (res.code == 1001 && res.data) {
                            this.oldTotal = JSON.parse(JSON.stringify(res.data.auditTotal))
                            let totalItem =
                            {
                                settleMoney: 0,
                                planMaterialAmount: 0,
                                receiveMaterialAmount: 0,
                                settleAmount: 0,
                                cumulativeSettleAmount: 0,
                                measuresCost: 0,
                                summaryMoney: 0,
                                cumulativeSettleMoney: 0,
                                measuresRatio: "",
                                measuresRatioId: "",
                                whetherAdjustPrice: 0,
                                planInvoiceMoney: 0,
                                settleInvoiceMoney: 0,
                                loanArrearsMoney: 0,
                                remark: "",
                                eventExplain: "",
                                rejectReason: "",
                                enclosureUrl: null,
                                deductionAmount: 1012,
                                marginAmount: 0,
                                processManagerId: "",
                                processTaskId: "",
                                processVersionId: "",
                                sealTypeId: "",
                                sealTypeName: "",
                            }
                            let billData = {
                                productSummarys: res.data.productSummarys,
                                differSummarys: res.data.differSummarys,
                                pumpSummarys: res.data.pumpSummarys,
                                childCycles: this.bindEngList,
                                additional: [],
                                smallVolumeSummarys: res.data.smallVolumeSummarys,
                                adjustDetailList: res.data.adjustDetailList || [],
                                totalList: [res.data.auditTotal || totalItem],
                                auditTotal: res.data.auditTotal || totalItem,
                                cycleId: res.data.cycleId || this.low.id,
                                currentTime: res.data.currentTime
                            }
                            let enclosureUrl = res.data?.auditTotal?.enclosureUrl.split('?&')
                            let files = []
                            enclosureUrl.forEach(item => {
                                files = [...files, ...JSON.parse(item)]
                            })
                            if (this.currenindex == 3 && row.sureSelletesStatus == 0) {
                                this.insideFiles = files
                                this.files = []
                            } else if (
                                this.currenindex == 3 && row.sureSelletesStatus != 0
                            ) {
                                queryInternalSettleData({ id: this.low.id }).then(res => {
                                    let enclosureUrl2 = res.data?.auditTotal?.enclosureUrl.split('?&')
                                    let files2 = []
                                    enclosureUrl2.forEach(item => {
                                        files2 = [...files2, ...JSON.parse(item)]
                                    })
                                    this.insideFiles = files2
                                    this.files = files
                                })
                            } else {
                                this.files = files
                            }
                            billData.differSummarys?.forEach(item => {
                                if (item.startTime && item.endTime) {
                                    item['timeSlot'] = [item.startTime, item.endTime]
                                }

                            })
                            billData.adjustDetailList?.forEach(item => {
                                if (item.startTime && item.endTime) {
                                    item['timeSlot'] = [item.startTime, item.endTime]
                                }

                            })
                            let additional = []
                            billData.productSummarys?.forEach(item => {
                                if (item.additionalMaterial) {
                                    let additionalMaterial = JSON.parse(item.additionalMaterial)
                                    let additionalChird = additionalMaterial.map(item2 => item2.name)
                                    additional = [...new Set([...additional, ...additionalChird])];

                                }
                            })

                            billData.additional = additional
                            this.billData = billData
                            console.log(this.billData)
                            this.billData.productSummarys?.forEach(item => {
                                let additionalMaterialArr = item.additionalMaterial ? JSON.parse(item.additionalMaterial) : []
                                this.billData.additional.forEach(item2 => {
                                    let obj = additionalMaterialArr.find(item3 => item3.name === item2)
                                    item[item2] = obj ? Number(obj.price).toFixed(2) : '';
                                });
                            })

                        }
                        this.billDig = true
                    })
                } else {
                    const queryMethod = (this.currenindex == 2 || (this.currenindex == 3 && this.mainRow.sureSelletesStatus == 0)) ? queryInternalSettleData : (this.currenindex == 4 && (row.settleStatus == 2 || row.settleStatus == 4)) ? queryProcessSettleData : queryConfirmSettleData
                    queryMethod({ id: this.low.id }).then(res => {
                        if (res.code == 1001 && res.data) {
                            this.oldTotal = JSON.parse(JSON.stringify(res.data.auditTotal))
                            let totalItem =
                            {
                                settleMoney: 0,
                                planMaterialAmount: 0,
                                receiveMaterialAmount: 0,
                                settleAmount: 0,
                                cumulativeSettleAmount: 0,
                                measuresCost: 0,
                                summaryMoney: 0,
                                cumulativeSettleMoney: 0,
                                measuresRatio: "",
                                measuresRatioId: "",
                                whetherAdjustPrice: 0,
                                planInvoiceMoney: 0,
                                settleInvoiceMoney: 0,
                                loanArrearsMoney: 0,
                                remark: "",
                                eventExplain: "",
                                rejectReason: "",
                                enclosureUrl: null,
                                deductionAmount: 1012,
                                marginAmount: 0,
                                processManagerId: "",
                                processTaskId: "",
                                processVersionId: "",
                                sealTypeId: "",
                                sealTypeName: "",
                            }
                            let billData = {
                                productSummarys: res.data.productSummarys,
                                differSummarys: res.data.differSummarys,
                                pumpSummarys: res.data.pumpSummarys,
                                childCycles: this.bindEngList,
                                additional: [],
                                smallVolumeSummarys: res.data.smallVolumeSummarys,
                                adjustDetailList: res.data.adjustDetailList || [],
                                totalList: [res.data.auditTotal || totalItem],
                                auditTotal: res.data.auditTotal || totalItem,
                                cycleId: res.data.cycleId || this.low.id,
                                currentTime: res.data.currentTime
                            }
                            if (this.currenindex == 4) {
                                billData['cycleProcessId'] = res.data.cycleProcessId
                                billData['settleMethod'] = res.data.settleMethod
                            }
                            let files = res.data?.auditTotal?.enclosureUrl ? JSON.parse(res.data.auditTotal.enclosureUrl) : []
                            if (this.currenindex == 3 && row.sureSelletesStatus == 0) {
                                this.insideFiles = files
                                this.files = []
                            } else if (
                                this.currenindex == 3 && row.sureSelletesStatus != 0
                            ) {
                                queryInternalSettleData({ id: this.low.id }).then(res => {
                                    let files2 = res.data?.auditTotal?.enclosureUrl ? JSON.parse(res.data.auditTotal.enclosureUrl) : []
                                    this.insideFiles = files2
                                    this.files = files
                                })
                            } else {
                                this.files = files
                            }
                            billData.differSummarys?.forEach(item => {
                                if (item.startTime && item.endTime) {
                                    item['timeSlot'] = [item.startTime, item.endTime]
                                }

                            })
                            billData.adjustDetailList?.forEach(item => {
                                if (item.startTime && item.endTime) {
                                    item['timeSlot'] = [item.startTime, item.endTime]
                                }

                            })
                            let additional = []
                            billData.productSummarys?.forEach(item => {
                                if (item.additionalMaterial) {
                                    let additionalMaterial = JSON.parse(item.additionalMaterial)
                                    let additionalChird = additionalMaterial.map(item2 => item2.name)
                                    additional = [...new Set([...additional, ...additionalChird])];

                                }
                            })

                            billData.additional = additional
                            this.billData = billData
                            console.log(this.billData)
                            this.billData.productSummarys?.forEach(item => {
                                let additionalMaterialArr = item.additionalMaterial ? JSON.parse(item.additionalMaterial) : []
                                this.billData.additional.forEach(item2 => {
                                    let obj = additionalMaterialArr.find(item3 => item3.name === item2)
                                    item[item2] = obj ? Number(obj.price).toFixed(2) : '';
                                });
                            })

                        }
                        this.billDig = true
                    })
                }


            } else {
                this.billData = this.$options.data().billData
                this.billDig = true
            }
        },
    },
};
</script>
<style scoped>
.table5>>>.redHead {
    color: red !important;
    /* 设置列名为红色 */
}
</style>
<style lang="scss" scoped>
.styleA {
    overflow: auto;
    max-height: calc(85vh - 266px);
    padding-right: 10px;
}

.styleB {
    overflow: auto;
    max-height: calc(85vh - 366px);
    padding-right: 10px;
}

.saledialoginfo {
    padding: 20px 20px 0 0px;
    max-height: calc(85vh - 220px);
}

.el-input,
.el-select {
    width: 240px;
}

.top_link {
    color: #008000;
}

.top_link:hover {
    cursor: pointer;
    opacity: 0.7;
}

.table_link {
    margin-left: 10px;
    color: $bg_color;
}

.table_link:hover {
    opacity: 0.8;
}

.tabtop {
    width: 378px;
    display: flex;
    border: $bg_color 1px solid;
    border-radius: 4px;
    margin: 20px 20px 0 20px;

    >div {
        height: 40px;
        width: 190px;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
        display: flex;
        align-items: center;

        .text {
            width: 188px;
            @include discen;
            line-height: 40px;
            color: $bg_color;
        }

        .active {
            width: 188px;
            @include discen;
            line-height: 40px;
            color: #ffffff;
            background: $bg_color;
            border-radius: 4px;
        }

        .hr {
            height: 20px;
            width: 2px;
            background: $bg_color;
        }
    }
}

.el-input,
.el-select {
    width: 227px;
}

.dialoginfo {
    padding: 0;
}

.form-title {
    font-size: 18px;
    margin: 10px 0;
}

.bill_top {
    display: flex;
    justify-content: flex-start;
    line-height: 35px;
    flex-wrap: wrap;

    .text {
        font-weight: 600;
        color: #000;
    }
}

.bill_title {
    font-size: 18px;
    font-weight: 600;
    padding: 15px 0;
}

.bill_title1 {
    font-size: 18px;
    font-weight: 600;
    padding: 20px 0;
}
</style>
    